import React, {useContext, useEffect, useState} from 'react';
import { withGoogleMap, GoogleMap } from "react-google-maps";
import { MarkerClusterer } from 'react-google-maps/lib/components/addons/MarkerClusterer';
import _ from 'lodash';
import MapMarker from './MapMarker';

import { GeolocationContext } from '../contexts/geolocation-context';
import { InfoWindowContextProvider } from '../contexts/infowindow-context'; 
import { MapContext } from '../contexts/map-context';

const Map = ({ markers }) => {
    let map;

    const [geolocationState, dispatchToGeolocation] = useContext(GeolocationContext);
    const [mapRef, setMapRef] = useContext(MapContext);

    useEffect(() => {
        setMapRef(map);
    }, []);

    useEffect(() => {
        const bounds = new google.maps.LatLngBounds();
        let hasExtendedBounds = false;
        const {southwest, northeast} = geolocationState.bounds;
        if (!southwest || !northeast) return
        markers.forEach(function(item) {
            var marker = new google.maps.Marker({
              position: { lat: item.latitude, lng: item.longitude }
            });
            if (
                item.latitude >= southwest.lat &&
                item.latitude <= northeast.lat &&
                item.longitude >= southwest.lng &&
                item.longitude <= northeast.lng
            ) {
                hasExtendedBounds = true;
                bounds.extend(marker.position);
            }
        });
        if (!hasExtendedBounds) {
            bounds.extend(southwest);
            bounds.extend(northeast);
        }
        map.fitBounds(bounds);
    }, [geolocationState.bounds]);
 
    return (
        <InfoWindowContextProvider>
            <GoogleMap
                ref={(ref) => map = ref}
                options={{ gestureHandling: "greedy", minZoom: 1 }}
            >
                <MarkerClusterer
                    averageCenter
                    enableRetinaIcons
                    clusterClass="map-cluster"
                    gridSize={50}
                >
                    {markers.map((marker, index) => 
                        <MapMarker key={index} marker={marker} />
                    )}
                </MarkerClusterer>
            </GoogleMap>
        </InfoWindowContextProvider>
    )
}

export default withGoogleMap(Map);